/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-24T10:10:29.729
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listKhmDemandApply,
	listKhmDemandApplyInit,
	listKhmDemandApplyByAuthorizations,
	deleteKhmDemandApply
	
} from '@api/rentmanage/KhmDemandApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listKhmDemandApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDemandApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmDemandApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDemandApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listKhmDemandApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listKhmDemandApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteKhmDemandApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteKhmDemandApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
